import React from 'react';
import './../style.css'
import { FaBars } from "react-icons/fa";
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';

import { useNavigate, Link } from 'react-router-dom';
const Header = () => {
    return (
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light" sticky='top'>
            <Container>
                <Navbar.Brand as={Link} to="/">Mohammad Asaduzzaman</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">HOME</Nav.Link>
                        <Nav.Link as={Link} to="/blogs">BLOGS</Nav.Link>
                        {/* <Nav.Link href="#about">ABOUT</Nav.Link> */}
                        {/* <Nav.Link href="#project">PROJECTS</Nav.Link> */}
                        {/* <Nav.Link href="#education">EDUCATION</Nav.Link> */}
                        {/* <Nav.Link href="#con">CONTACT</Nav.Link> */}

                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar>

    );
};

export default Header;